module.exports = __webpack_public_path__ + "img/member-icon.092da1b8.png";